import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import FilterWithChart from 'src/components/Search/Resume/Filters/FilterWithChart';
import translation from 'src/components/translation';
import { ClusterKey } from 'src/types/search/common/clusters';

import styles from './styles.less';

const TrlKeys = {
    title: 'resumesearch.clusters.age',
    unit: 'resumesearch.clusters.age.unit',
    from: 'resumesearch.clusters.age.from',
    to: 'resumesearch.clusters.age.to',
    fromTo: 'resumesearch.clusters.age.fromto',
    labelFrom: 'employer.resumesSearch.ageFrom',
    labelTo: 'employer.resumesSearch.ageTo',
    onlyWithAge: 'employer.resumesSearch.onlyWithAge',
    resumes: 'employer.resumesSearch.resumes',
    emptyMessage: 'novaFilters.age.empty',
};

const Age: TranslatedComponent = ({ trls }) => {
    return (
        <div className={styles.wrapper}>
            <FilterWithChart
                title={`${trls[TrlKeys.title]}, ${trls[TrlKeys.unit]}`}
                name={ClusterKey.Age}
                emptyMessage={trls[TrlKeys.emptyMessage]}
                trls={{
                    from: trls[TrlKeys.from],
                    to: trls[TrlKeys.to],
                    fromTo: trls[TrlKeys.fromTo],
                    labelFrom: trls[TrlKeys.labelFrom],
                    labelTo: trls[TrlKeys.labelTo],
                    onlyWithTitle: trls[TrlKeys.onlyWithAge],
                    resumes: trls[TrlKeys.resumes],
                }}
            />
        </div>
    );
};

export default translation(Age);
